import { Link } from 'react-router-dom';
import { ArrowRightIcon } from '@heroicons/react/24/outline';

const FooterFamilyCallout = () => {
  return (
    <section className="py-12 bg-gradient-to-r from-secondary/20 via-muted/30 to-accent/20">
      <div className="container mx-auto px-4">
        <div className="text-center">
          <Link 
            to="/thrivefamily" 
            className="inline-flex items-center gap-2 text-lg font-bold text-primary hover:text-primary/80 transition-colors duration-300 group min-h-[48px]"
          >
            Supporting a parent or loved one? Explore SeniorThrive for Families
            <ArrowRightIcon className="w-5 h-5 group-hover:translate-x-1 transition-transform duration-300" />
          </Link>
        </div>
      </div>
    </section>
  );
};

export default FooterFamilyCallout;
